var _style, _defs, _defs2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseConversationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.8 17.9",
    style: {
      enableBackground: "new 0 0 21.8 17.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{clip-path:url(#SVGID_4_);}\n\t.st2{fill:none;stroke:#1C3152;stroke-width:0.81;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#1C3152;stroke-width:0.62;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 2.9,
    y: 2.1,
    width: 15.9,
    height: 13.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 2.9,
    y: 2.1,
    width: 15.9,
    height: 13.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17.8,5.9H4.1C4,5.9,3.8,5.7,3.8,5.6V3.5c0-0.2,0.2-0.3,0.3-0.3h13.7c0.2,0,0.3,0.1,0.3,0.3v2.1 C18.1,5.7,18,5.9,17.8,5.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M4.5,5.9v8.4c0,0.2,0.1,0.4,0.3,0.4c0,0,0,0,0,0h12.3c0.2,0,0.3-0.2,0.3-0.4c0,0,0,0,0,0V5.9H4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M12.8,9c0,0.2-0.1,0.4-0.3,0.4c0,0,0,0,0,0h-3C9.2,9.5,9,9.3,9,9V8.5c0-0.2,0.1-0.4,0.4-0.4h3 c0.2,0,0.4,0.2,0.3,0.4V9z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseConversationIcon);
export default __webpack_public_path__ + "static/media/close-conversation-icon.ff289f6c2f6ed8ee33382569017fc17d.svg";
export { ForwardRef as ReactComponent };